var _circle, _circle2, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "black",
    fillOpacity: 0.12
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12,
    fill: "#39BAB5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9528_83122",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 18,
    height: 18,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9528_83122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.801 15.025L13.001 14.125L14.1635 15.025C14.301 15.125 14.4447 15.1283 14.5947 15.0348C14.7447 14.9408 14.7885 14.8063 14.726 14.6313L14.276 13.15L15.4947 12.1938C15.6322 12.0813 15.673 11.9375 15.617 11.7625C15.5605 11.5875 15.4385 11.5 15.251 11.5H13.826L13.3385 10.0188C13.276 9.8438 13.1635 9.7563 13.001 9.7563C12.8385 9.7563 12.726 9.8438 12.6635 10.0188L12.176 11.5H10.751C10.5635 11.5 10.4385 11.5875 10.376 11.7625C10.3135 11.9375 10.3572 12.0813 10.5072 12.1938L11.6885 13.15L11.2385 14.6313C11.176 14.8063 11.2197 14.9408 11.3697 15.0348C11.5197 15.1283 11.6635 15.125 11.801 15.025ZM13.001 20.4438C12.9385 20.4438 12.876 20.4438 12.8135 20.4438C12.751 20.4438 12.6947 20.4313 12.6447 20.4063C11.0072 19.8938 9.65723 18.878 8.59473 17.359C7.53223 15.8405 7.00098 14.1625 7.00098 12.325V8.7813C7.00098 8.4688 7.09173 8.18755 7.27323 7.93755C7.45423 7.68755 7.68848 7.5063 7.97598 7.3938L12.476 5.7063C12.651 5.6438 12.826 5.61255 13.001 5.61255C13.176 5.61255 13.351 5.6438 13.526 5.7063L18.026 7.3938C18.3135 7.5063 18.548 7.68755 18.7295 7.93755C18.9105 8.18755 19.001 8.4688 19.001 8.7813V12.325C19.001 14.1625 18.4697 15.8405 17.4072 17.359C16.3447 18.878 14.9947 19.8938 13.3572 20.4063C13.2947 20.4313 13.176 20.4438 13.001 20.4438Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolice);
export default __webpack_public_path__ + "static/media/police.a463d02171d2ffe88022b791ee88e775.svg";
export { ForwardRef as ReactComponent };